/**
 * 텍스트가 숫자 형식으로 변환 가능한지 검증
 * @param strValue
 * @returns
 */
export function isCountInvalidUtil(strValue: number | string): boolean {
  if (!strValue) return true;

  const numValue = +strValue;

  return isNaN(numValue) || numValue > 1000000000000000;
}
